<template>
    <div class="uk-padding">


        <div class="uk-animation-scale-down uk-margin-large-top uk-padding">
            <h1 class="uk-text-primary uk-text-center">End Of Test</h1>

            <div class="uk-text-center">
                <!-- <p>{{totalAnswered}}/{{totalTestQuestions}} Answered</p> -->
            </div>
            <div class="uk-text-center uk-flex uk-flex-center">
                <button class="uk-button uk-button-primary uk-margin-right" @click="previousFrameQuestion()">Go Back</button>
                <button class="uk-button uk-button-primary uk-margin-left" @click="submitUserAnswers()">Submit Answers</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        question: {
            type: Object
        },
        questionNumber: {
            type: Number
        },
        frameNum:{
            type: Number,
            default: 0
        },
        nextFrame:{
            type: Function
        },
        previousFrame: {
            type: Function
        },
        updateAnswer:{
            type: Function
        },
        answeredQuestions: {
            type: Number,
            default: 0
        },
        answersArray: {
            type: Array,
            default: function(){
                return []
            }
        },
        totalQuestions: {
            type: Number,
            default: 1
        },
        checkTest: {
            type: Function
        }
    },
    data () {
        return {
            answer: "none",
            selected_el: "",
            width: window.innerWidth
        }
    },
    computed: {
        totalTestQuestions(){
            return this.answersArray.length
        },
        totalAnswered(){
            return this.answersArray.reduce((acc, cv) => {
                if (cv !== "none"){
                    acc+=1;
                }
                return acc
            }, 0);
        }
    },
    methods: {
        previousFrameQuestion(){
            this.previousFrame(this.frameNum-1)
        },
        nextFrameQuestion(){
            this.nextFrame(this.frameNum+1)
        },
        submitUserAnswers(){
            this.checkTest()
            this.nextFrameQuestion()
        }

    }
}
</script>

<style lang="less" scoped>

</style>
